<template>
  <el-dialog
    :title="$t('accountBond.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <div style="text-align: center">
      <p>{{ $t('accountBond.confirmDeleteBond') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('accountBond.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAccountBond">{{ $t('accountBond.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAccountBond } from '@/api/admin/accountBondApi'

export default {
  name: 'DeleteAccountBond',
  data() {
    return {
      dialogVisible: false,
      currentBond: null
    }
  },
  methods: {
    open(bond) {
      this.currentBond = bond
      this.dialogVisible = true
    },
    async deleteAccountBond() {
      try {
        await deleteAccountBond(this.currentBond)
        this.$message.success(this.$t('accountBond.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>